import React from 'react';
import {connect} from 'react-redux';
import {Col, Modal, Row} from 'react-bootstrap';
import {alertActions, userActions, utilActions} from '../../../_actions';
import {userService} from '../../../_services';
import {Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import {ErrorMessage, LoadingBoton, RoleID} from '../../../_helpers';
import _ from 'lodash';
import {empresaActions} from '../../../_actions/empresa.actions';
import Select from 'react-select';
import authService from '../../../_services/authService';

class FormUsuarioAdmin extends React.Component {

    constructor(props) {

        super(props);
        this.state.nuevo = this.props.usuario === undefined;
        this.state.esAdmin = authService.hasAuthority('ROLE_ADMIN');
        this.usuarioExiste = _.debounce(this.usuarioExiste, 300);
        this.mailExiste = _.debounce(this.mailExiste, 300);
    }

    componentDidMount() {
        if (this.props.empresas === undefined && this.state.esAdmin) this.props.traerEmpresas();
        if (this.props.roles === undefined) this.props.traerRolesAdmin();

    }

    usuarioExiste = (value) => {
        let valorFinal = false
        valorFinal = userService.chequearUsuarioExiste(value).then(
            data => {

                if (data.status === 1) valorFinal = false;
                if (data.status === 3) valorFinal = true;
                return valorFinal;
            },
            error => {
                valorFinal = true
            }
        );
        return valorFinal;
    }

    mailExiste = (value) => {
        let valorFinal = false
        valorFinal = userService.chequearMailExiste(value).then(
            data => {
                if (data.status === 1) valorFinal = false;
                if (data.status === 3) valorFinal = true;
                return valorFinal;
            },
            error => {
                valorFinal = true
            }
        );
        return valorFinal;
    }

    setGrabando = (grab) => {
        this.setState({grabando: grab});
    }

    state = {
        nuevo: true,
        codigoEnviado: false,
        codigoIngresado: '',
        mailValidado: false,
        grabando: false,
        mostrar: false,
        esAdmin: false
    };

    render() {
        let inic = {
            nombre: '',
            mail: '',
            empresa: {id: this.state.esAdmin ? '' : authService.getLoggedUser().detail.empresa.id},
            rol: {id: ''}
        }
        //traer de la base los datos del usuario
        let {usuario, empresas, roles} = this.props;
        if (!usuario) usuario = {};

        const {nuevo} = this.state;

        let rolesFinal = this.state.esAdmin ? roles : roles?.filter(it => it.id != RoleID.ADMIN);

        const thisAdentro = this;
        let validateActualizar = {
            nombre: Yup.string().min(2, 'Muy corto').max(100, 'No puede exceder los 100 caracteres').required('Requerido'),
            mail: Yup.string()
                .min(2, 'Muy corto')
                .max(100, 'No puede exceder los 100 caracteres')
                .email('Mail incorrecto')
                .test('checkDuplUsername', 'Mail existente', function (value) {
                    if (!nuevo && usuario && value === inic.mail)
                        return true;
                    else return thisAdentro.mailExiste(value);
                }).required('Requerido'),
        };

        let validateNuevo = {};

        let validacionFinal = Object.assign(validateActualizar, validateNuevo);

        const validationSchema = Yup.object().shape(
            validacionFinal
        );

        if (usuario !== undefined && usuario !== {}) inic = utilActions.setearValores(inic, usuario);
        return (
            <Modal show={this.props.show} onHide={() => this.props.handleClose()} backdrop="static" keyboard={false}>
                <Modal.Header className="bg-iot text-dark" closeButton>
                    <Modal.Title>Usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body className="th_iot">
                    <div>
                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            validationSchema={validationSchema}
                            onSubmit={(values) => {

                                this.setGrabando(true);

                                userService.grabarAdmin(values).then(
                                    user => {
                                        this.props.handleClose();

                                        this.props.enviarSuccess('El usuario se ha creado/actualizado exitosamente.');
                                        this.setGrabando(false);
                                    },
                                    error => {
                                        this.props.enviarError(error);
                                        this.setGrabando(false);
                                    }
                                );

                            }}>
                            {({errors, touched, values, handleSubmit, setFieldValue}) => (
                                <Form>
                                    <Row>
                                        <Col sm={12}>
                                            <label htmlFor="nombre">Nombre</label>
                                            <ErrorMessage name={`nombre`}/>
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text"><i className="icon-admin"></i>
                                                    </div>
                                                </div>
                                                <Field className="form-control" name="nombre"/>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>

                                        <Col sm={12}>
                                            <label htmlFor="mail">Mail </label>
                                            <ErrorMessage name={`mail`}/>
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text"><i className="icon-mail"></i>
                                                    </div>
                                                </div>
                                                <Field className="form-control" name="mail"/>
                                            </div>
                                        </Col>
                                        <Col sm={12}>
                                            <label className="font-weight-bold"
                                                   htmlFor="asignado">Rol </label><ErrorMessage name={`rol`}/>
                                            <Select
                                                isClearable
                                                isMulti={false}
                                                value={rolesFinal ? rolesFinal.filter(obj => values.rol.id == obj.id) : []}
                                                name={`rol`}
                                                getOptionLabel={option => `${authService.formatRol(option.authority)}`}
                                                getOptionValue={option => option.id}
                                                onChange={so => {
                                                    setFieldValue(`rol`, so ? so : {})
                                                }}
                                                isSearchable={true}
                                                placeholder="Seleccione"
                                                options={rolesFinal}
                                            />
                                        </Col>
                                        {this.state.esAdmin && values.rol.id != '' && values.rol.id != RoleID.ADMIN &&
                                        <Col sm={12}>
                                            <label className="font-weight-bold"
                                                   htmlFor="asignado">Empresa </label><ErrorMessage name={`empresa`}/>
                                            <Select
                                                isClearable
                                                isMulti={false}
                                                value={empresas ? empresas.filter(obj => values.empresa.id == obj.id) : []}
                                                name={`empresa`}
                                                getOptionLabel={option => `${option.nombre}`}
                                                getOptionValue={option => option.id}
                                                onChange={so => {
                                                    setFieldValue(`empresa`, so ? so : [])
                                                }}
                                                isSearchable={true}
                                                placeholder="Seleccione"
                                                options={empresas}
                                            />
                                        </Col>}
                                        {nuevo && <Col>
                                            <p>
                                                Se generara automaticamente una contraseña que sera enviada al usuario
                                                via email.
                                            </p>
                                        </Col>}
                                    </Row>
                                    <div className="row justify-content-center mt-5 mb-5">

                                        <button className="btns btns-secundario" type="submit"
                                                disabled={this.state.grabando}>
                                            {(nuevo) && 'Crear usuario'}
                                            {(!nuevo) && 'Grabar cambios'}
                                            <LoadingBoton grabando={this.state.grabando}/>
                                        </button>

                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Modal.Body>
            </Modal>
        )
    };
}

function mapState(state) {
    const {empresas} = state.empresa;
    const {roles} = state.users;
    return {empresas, roles};
}

const actionCreators = {
    enviarError: alertActions.error,
    enviarSuccess: alertActions.success,
    traerInfoGral: userActions.traerInfoGral,
    traerEmpresas: empresaActions.traerEmpresas,
    traerRolesAdmin: userActions.traerRolesAdmin
}

const connectedFormUsuarioAdmin = connect(mapState, actionCreators)(FormUsuarioAdmin);
export {connectedFormUsuarioAdmin as FormUsuarioAdmin};